import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { makeStyles, Theme } from '@material-ui/core';


const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    margin: '15px 0',
    '& .MuiFormLabel-root': {
      color: '#5C657C',
      fontWeight: 500,
      fontSize: 14,
      fontFamily: theme.typography.h1.fontFamily
    },
    '& .MuiFormGroup-root': {
      flexDirection: 'row'
    }
  }
}));

interface RadioOption {
  label: string
  value: any
}

interface RadioButtonsGroupProps {
  id: string
  formLabel: string
  options: RadioOption[]
  value?: any
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void
}

const RadioButtonsGroup: React.FC<RadioButtonsGroupProps> = ({
  id,
  formLabel,
  options,
  value,
  handleChange
}) => {
  const styles = useStyles();
  return (
    <FormControl component='fieldset' classes={styles}>
      <FormLabel component='label'>{formLabel}</FormLabel>
      <RadioGroup aria-label={formLabel} name={id} value={value} onChange={handleChange}>
        {options.map((opt: RadioOption) => <FormControlLabel checked={value === opt.value} key={opt.label} value={opt.value} control={<Radio />} label={opt.label} />)}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioButtonsGroup;
